import sortableList from "./sortableList.component";

const sortableListModule = angular
  .module("app.components.sortableList", [])
  .component("sortableList", sortableList);

export default sortableListModule;



// WEBPACK FOOTER //
// ./src/components/sortableList/sortableList.module.js